import { Component, computed, input, output } from '@angular/core';
import { webDtos } from '@vectronic/openApi-admin';
import { userDtos } from '@vectronic/openApi-customer';
import { roleOrder } from '@vectronic/ui';
import { DeviceItem } from '@vectronic/util';
import { UserRolesTableComponent } from '../user-roles-table/user-roles-table.component';

@Component({
  selector: 'table-device-users-details',
  templateUrl: './device-users-details.component.html',
  styleUrls: ['./device-users-details.component.scss'],
  imports: [UserRolesTableComponent],
})
export class DeviceUsersDetailsComponent<T extends DeviceItem> {
  deviceType = input<T>();
  device = input<webDtos.DeviceAdmin>();

  deleteShare = output<userDtos.Share>();
  updateShare = output<userDtos.Share>();
  createShare = output();

  sortedShares = computed(() => {
    const shares = this.device()?.shares;
    if (!shares) {
      return [];
    }

    return [...shares].sort((a, b) => {
      const aOrder = roleOrder.get(a.role) ?? 4;
      const bOrder = roleOrder.get(b.role) ?? 4;
      return aOrder - bOrder;
    });
  });
}
